import { getUserAgent } from "universal-user-agent"
import { UAParser } from "ua-parser-js"

const getUAInfo = () => {
    const userAgent = getUserAgent()
    const parser = new UAParser(userAgent); // you need to pass the user-agent for nodejs
    const info = parser.getResult();
    return info;
}

const generateDeviceId = (uainfo) => {
    //   console.log(device);
    const deviceChunks = []
    if (uainfo?.device?.type) {
        deviceChunks.push(uainfo?.device?.type)
    }
    // if (uainfo?.device?.model) {
    //     deviceChunks.push(uainfo?.device?.model)
    // }
    if (uainfo?.device?.vendor) {
        deviceChunks.push(uainfo?.device?.vendor)
    }
    if (uainfo?.os?.name) {
        deviceChunks.push(uainfo?.os?.name)
    }
    if (uainfo?.os?.version) {
        deviceChunks.push(uainfo?.os?.version)
    }
    if (uainfo?.cpu?.architecture) {
        deviceChunks.push(uainfo?.cpu?.architecture)
    }
    if (uainfo?.browser?.name) {
        deviceChunks.push(uainfo?.browser?.name)
    }

    let deviceId = deviceChunks.join(' ');
    // return device;
    return deviceId;
}


export const useDevice = () => {

    const uainfo = getUAInfo();
    const id = generateDeviceId(uainfo)

    return {
        uainfo,
        id,
    };
};
